var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3512 0H10.6667C3.85778 0 0 3.85778 0 10.6667V29.3334C0 36.1422 3.85778 40 10.6667 40H29.3512C36.16 40 40 36.1422 40 29.3334V10.6667C40 3.85778 36.16 0 29.3512 0Z",
    fill: "#CE2600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5041_28151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.64 27.8131C15.1994 27.8131 13.2129 25.8266 13.2129 23.3859V12.709H11.39C9.8098 12.709 8.52539 13.9932 8.52539 15.5734V29.6359C8.52539 31.2162 9.8098 32.5006 11.39 32.5006H24.4107C25.991 32.5006 27.2754 31.2162 27.2754 29.6359V27.8131H17.64Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.442 10.3646C31.442 8.78231 30.1597 7.5 28.5775 7.5H17.64C16.0577 7.5 14.7754 8.78231 14.7754 10.3646V23.3854C14.7754 24.9677 16.0577 26.25 17.64 26.25H28.5775C30.1597 26.25 31.442 24.9677 31.442 23.3854V10.3646Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5041_28151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fe9d56dbbf530f7adc9b0f843d72fa60.svg";
export { ForwardRef as ReactComponent };